/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceVarsSetMutationRequest, StreamerBoxStreamerBoxDeviceVarsSetMutationResponse, StreamerBoxStreamerBoxDeviceVarsSetPathParams } from "../models/StreamerBoxStreamerBoxDeviceVarsSet";

export function getStreamerBoxStreamerBoxDeviceVarsSetUrl(uuidOrId: StreamerBoxStreamerBoxDeviceVarsSetPathParams["uuidOrId"]) {
  const res = { method: 'POST', url: `/streamer-box/devices/${uuidOrId}/vars` as const }
  return res
}

/**
 * @description Sets one or more public device variables. Variable names are stored with a `PUBLIC_` prefix on the device.
 * @summary Set device variables
 * {@link /streamer-box/devices/:uuidOrId/vars}
 */
export async function streamerBoxStreamerBoxDeviceVarsSet(uuidOrId: StreamerBoxStreamerBoxDeviceVarsSetPathParams["uuidOrId"], data: StreamerBoxStreamerBoxDeviceVarsSetMutationRequest, config: Partial<RequestConfig<StreamerBoxStreamerBoxDeviceVarsSetMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StreamerBoxStreamerBoxDeviceVarsSetMutationResponse, ResponseErrorConfig<Error>, StreamerBoxStreamerBoxDeviceVarsSetMutationRequest>({ method : "POST", url : getStreamerBoxStreamerBoxDeviceVarsSetUrl(uuidOrId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}